// Admin bo'limi: layout, Users, Branches & teams, Audit log (uz)
export default {
  tabs: {
    users: "Foydalanuvchilar",
    branches: "Filiallar",
    settings: "Sozlamalar",
    import: "Sheets import",
    audit: "Audit jurnali",
  },
  audit: {
    title: "Audit jurnali",
    ownerOnly: "Faqat egasi uchun",
    ownerOnlyDesc: "Audit jurnali faqat kompaniya egasiga ochiq.",
    readOnly: "Faqat o'qish",
    subtitle: "Tizimdagi har bir o'zgarish · faqat egasi",
    userAll: "Foydalanuvchi: hammasi",
    modelAll: "Obyekt turi: hammasi",
    actionPlaceholder: "Amal (update, login…)",
    searchPlaceholder: "Obyekt, haydovchi ismi, ID bo'yicha qidirish",
    emptyTitle: "Hodisalar yo'q",
    emptyFiltered: "Bu filtrlarga mos hodisa yo'q.",
    emptyDesc: "Odamlar ishlagani sari o'zgarishlar shu yerda ko'rinadi.",
    col: { time: "Vaqt", user: "Foydalanuvchi", action: "Amal", object: "Obyekt", change: "O'zgarish (eski → yangi)", ip: "IP" },
    events: "hodisa",
    system: "tizim",
    yes: "ha",
    no: "yo'q",
    more: "+{{n}} ta yana",
    requestId: "So'rov ID",
    field: "Maydon",
    old: "Eski",
    new: "Yangi",
    immutable: "Audit jurnali yozuvlarini tahrirlab yoki o'chirib bo'lmaydi.",
    model: {
      all: "Barcha obyektlar",
      auth: "Kirish",
      user: "Foydalanuvchi",
      branch: "Filial",
      driver: "Haydovchi",
      application: "Ariza",
      carrier: "Carrier",
      job: "Vakansiya",
      approval: "Tasdiq",
      setting: "Sozlamalar",
      expense: "Xarajat",
      salary: "Maosh",
      bonus: "Bonus",
      driverdocument: "Driver hujjati",
    },
  },
  branches: {
    title: "Filiallar",
    subtitle_one: "{{count}} filial · {{recruiters}} recruiter",
    subtitle_other: "{{count}} filial · {{recruiters}} recruiter",
    newBranch: "+ Yangi filial",
    emptyTitle: "Hali filial yo'q",
    emptyDesc: "Avval birinchi filialni yarating, keyin recruiterlarni qo'shing.",
    card: "Filiallar",
    col: { branch: "Filial", manager: "Menejerlar", timezone: "Vaqt mintaqasi", recruiters: "Recruiterlar" },
    tz: {
      title: "Vaqt mintaqalari",
      branchTime: "Filial vaqti",
      branchTimeDesc: "Har bir filialning o'z vaqt mintaqasi bor (yuqorida)",
      driverTime: "Haydovchi vaqti",
      driverTimeDesc: "Haydovchining shtatidan: CST, EST, MST, PST",
      reminders: "Eslatmalar",
      remindersDesc: "Haydovchi vaqtida belgilanadi, ikkalasida ko'rsatiladi",
      today: "Hisobotlarda “bugun”",
      todayDesc: "Filial vaqti",
      tashkent: "Toshkent",
      chicago: "Chikago",
      newYork: "Nyu-York",
      losAngeles: "Los-Anjeles",
    },
    kv: { manager: "Menejerlar", timezone: "Vaqt mintaqasi", hours: "Ish vaqti", address: "Manzil", recruiters: "Recruiterlar" },
    assignHint: "Menejer va recruiterlar Xodimlar → Tahrirlash orqali biriktiriladi.",
    managerHint: "Menejer Foydalanuvchilar → Tahrirlash orqali biriktiriladi.",
    editTitle: "{{name}} ni tahrirlash",
    newTitle: "Yangi filial",
    create: "Filial yaratish",
    name: "Nomi",
    namePlaceholder: "E filiali",
    code: "Kodi",
    codePlaceholder: "E",
    hoursHint: "Masalan 17:00–02:00 Toshkent (haydovchilar kuni)",
    nameRequired: "Nom majburiy.",
    codeRequired: "Kod majburiy.",
    saved: "Filial saqlandi",
    created: "Filial yaratildi",
    saveFailed: "Filialni saqlab bo'lmadi.",
  },
  users: {
    title: "Foydalanuvchilar",
    subtitle_one: "{{count}} foydalanuvchi · {{branches}} filial",
    subtitle_other: "{{count}} foydalanuvchi · {{branches}} filial",
    newUser: "+ Yangi foydalanuvchi",
    searchPlaceholder: "Ism yoki login bo'yicha qidirish",
    roleAll: "Rol: hammasi",
    branchAll: "Filial: hammasi",
    statusAll: "Holat: hammasi",
    active: "Faol",
    blocked: "Bloklangan",
    emptyFiltered: "Bu filtrlarga mos foydalanuvchi yo'q",
    emptyTitle: "Hali foydalanuvchi yo'q",
    emptyDesc: "Jamoangizni “+ Yangi foydalanuvchi” orqali qo'shing.",
    col: { name: "Ism", role: "Rol", branch: "Filial", drivers: "Haydovchilar", lastLogin: "Oxirgi kirish", twofa: "2FA", status: "Holat", actions: "Amallar" },
    never: "Hali kirmagan",
    alsoIn: "yana: {{names}}",
    on: "Yoqilgan",
    off: "O'chiq",
    users: "foydalanuvchi",
    unblock: "Blokdan chiqarish",
    block: "Bloklash",
    cannotBlockSelf: "O'zingizni bloklay olmaysiz",
    moreActions: "Boshqa amallar",
    setPassword: "Yangi parol berish…",
    reset2fa: "2FA ni tiklash",
    unblocked: "{{name}} blokdan chiqarildi",
    passwordSet: "{{name}} uchun yangi parol qo'yildi",
    twofaReset: "{{name}} uchun 2FA tiklandi",
    actionFailed: "Amal bajarilmadi",
    form: {
      editTitle: "{{name}} ni tahrirlash",
      newTitle: "Yangi foydalanuvchi",
      newDesc: "Vaqtinchalik parolni siz qo'yasiz va xodimga topshirasiz; u birinchi kirishda almashtiradi.",
      create: "Yaratish",
      firstName: "Ism",
      lastName: "Familiya",
      username: "Login",
      usernamePlaceholder: "ism.familiya",
      password: "Vaqtinchalik parol",
      passwordHint: "Kamida 10 ta belgi. Saqlagach yana bir marta ko'rsatiladi.",
      random: "Tasodifiy",
      role: "Rol",
      phone: "Telefon",
      branch: "Filial",
      chooseBranch: "Filialni tanlang",
      extraBranches: "Qo'shimcha filiallar",
      extraBranchesHint: "Asosiy filialidan tashqari. Bir filialni bir nechta menejer boshqarishi mumkin.",
      nothingToChoose: "Tanlash uchun hali hech narsa yo'q.",
      firstNameRequired: "Ism majburiy.",
      usernameInvalid: "3-30 belgi: kichik lotin harflar, raqam, nuqta, pastki chiziq yoki defis.",
      passwordShort: "Kamida 10 ta belgi.",
      branchRequired: "Bu rol uchun filial majburiy.",
      saved: "Foydalanuvchi saqlandi",
      created: "Foydalanuvchi yaratildi",
    },
    credentials: {
      title: "Kirish ma'lumotlari: {{name}}",
      desc: "Bir marta ko'rsatiladi. Shaxsan yoki shaxsiy xabarda topshiring; xodim birinchi kirishda o'z parolini qo'yadi.",
      username: "Login",
      password: "Vaqtinchalik parol",
      copyAll: "Ikkalasini nusxalash",
      done: "Tayyor",
    },
    setPasswordModal: {
      title: "{{name}} uchun yangi parol",
      desc: "Joriy parol darhol ishlamay qoladi. Xodim buni birinchi kirishda almashtiradi.",
      password: "Vaqtinchalik parol",
      random: "Tasodifiy",
      save: "Parolni qo'yish",
      failed: "Parolni qo'yib bo'lmadi.",
      saveFailed: "Foydalanuvchini saqlab bo'lmadi.",
    },
    blockModal: {
      title: "{{name}} bloklansinmi?",
      blockReassign: "Bloklash va qayta biriktirish",
      block: "Bloklash",
      body: "{{name}} tizimdan chiqariladi va boshqa kira olmaydi. Hech narsa o'chirilmaydi: tarix va audit jurnali saqlanadi.",
      work: "{{first}} ning ishlari nima bo'ladi",
      drivers_one: "{{count}} haydovchi",
      drivers_other: "{{count}} haydovchi",
      reassignAll: "Hammasini bitta recruiterga biriktirish",
      chooseRecruiter: "Recruiterni tanlang",
      returnToPool: "{{branch}} pooliga qaytarish ({{manager}} biriktiradi)",
      noDrivers: "Qayta biriktiriladigan haydovchi yo'q.",
      notify: "{{manager}} va yangi egasiga xabar berish",
      notifyManager: "{{manager}} ga xabar berish",
      chooseRecruiterError: "Haydovchilarni qabul qiladigan recruiterni tanlang.",
      blocked: "{{name}} bloklandi.",
      moved_one: "{{count}} haydovchi ko'chirildi.",
      moved_other: "{{count}} haydovchi ko'chirildi.",
      failed: "Foydalanuvchini bloklab bo'lmadi.",
    },
  },
  // Ruxsatlar oynasi (owner): filial menejeri va team lead uchun
  access: {
    open: "Ruxsatlar",
    title: "Ruxsatlar · {{name}}",
    intro: {
      branch_manager: "Filial menejeri faqat o'z filiallarini ko'radi. Shu filiallar ichida unga nimalar ochiq bo'lishini tanlang.",
    },
    groups: { sections: "Bo'limlar", drivers: "Driverlar", carriers: "Carrier va vakansiyalar" },
    perm: {
      reports: { label: "Hisobotlar", desc: "O'z filiali uchun Hisobotlar sahifasi" },
      approvals: { label: "Tasdiqlashlar", desc: "Ishga olish, o'tkazish va xarajat so'rovlarini ko'radi va hal qiladi. O'chirilsa, so'rovlar kompaniya egasiga boradi." },
      budget: { label: "Budjet va xarajatlar", desc: "Filial budjeti, rejasi va xarajatlari" },
      pay: { label: "Maosh va bonuslar", desc: "Xodimlar maoshi va bonuslarini ko'radi va belgilaydi (profilda ham)" },
      users: { label: "Xodimlarni boshqarish", desc: "Admin → Xodimlar: recruiterlarni qo'shadi, tahrirlaydi va bloklaydi" },
      drivers_sensitive: { label: "Maxfiy ma'lumotlar", desc: "Tug'ilgan sana va CDL raqamini to'liq ko'radi va o'zgartiradi" },
      drivers_transfer: { label: "Driverlarni o'tkazish", desc: "Driverni boshqa recruiterga yoki poolga o'tkazadi" },
      drivers_archive: { label: "Driverlarni arxivlash", desc: "Driverni arxivlaydi va arxivdan qaytaradi" },
      carriers_edit: { label: "Qo'shish va o'zgartirish", desc: "Carrier va vakansiyalarni qo'shadi, o'zgartiradi, arxivlaydi. Ko'rish hammaga ochiq." },
    },
    custom: "maxsus",
    customHint: "Ruxsatlari rol standartidan farq qiladi",
    reset: "Rol standartiga qaytarish",
    applyNote: "O'zgarish darhol kuchga kiradi, xodim qayta kirishi shart emas.",
    saved: "Ruxsatlar saqlandi · {{name}}",
    conflict: "Bu ruxsatlarni hozirgina boshqa birov o'zgartirdi. Eng so'nggi holat ko'rsatildi.",
    notEditable: "Ruxsatlar faqat filial menejerlari uchun belgilanadi.",
    roleChangeHint: "Rol o'zgarsa, maxsus ruxsatlar yangi rol standartiga qaytadi.",
  },
};
